import isPlainObject from 'lodash/isPlainObject';

/**
 * Record fields that hold a free-form key/value map whose keys should each
 * become their own CSV column. `customFields` is used by most entities;
 * usage events call the same concept `properties`.
 */
export const DYNAMIC_EXPORT_MAP_FIELDS = [
  'customFields',
  'properties',
] as const;

/**
 * Appends `<mapField>.<key>` headers for every key found in any record's
 * dynamic map fields, so a CSV export never drops a value that only some rows
 * carry. Keys are added in first-seen order after the static headers.
 */
export function collectDynamicExportHeaders(
  staticHeaders: string[],
  results: unknown[],
): string[] {
  const headers = [...staticHeaders];
  const seen = new Set(headers);
  for (const mapField of DYNAMIC_EXPORT_MAP_FIELDS) {
    for (const record of results) {
      const map = (record as Record<string, unknown> | null)?.[mapField];
      if (!isPlainObject(map)) {
        continue;
      }
      for (const key of Object.keys(map as Record<string, unknown>)) {
        const header = `${mapField}.${key}`;
        if (!seen.has(header)) {
          seen.add(header);
          headers.push(header);
        }
      }
    }
  }
  return headers;
}
